var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.customClass }, [
    _vm._v(_vm._s(_vm.formatValue)),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }